export const QUERY_KEYS = {
  nonMemberPtInfo: 'nonMemberPtInfo',
  sendNonMemberChgCncl: 'sendNonMemberChgCncl',
};
